import { Content } from "@prismicio/client";
import React, { useEffect, useState } from "react";
import { EFixedBarPosition } from "@middleware/types";
import { getFromStorage } from "@middleware/helpers/global/sessions";
import {
  MAIL_CAPTURE_MODAL,
  MAIL_CAPTURE_SUBMITTED,
  MODAL_OPENING_DELAY,
} from "@middleware/constants";
import EmailCaptureModal from "@components/commun/Modals/EmailCaptureModal/EmailCaptureModal";
import FixedBar from "../FixedBar/FixedBar";
import style from "./MailCaptureBar.module.scss";

interface Props {
  mailCaptureData?:
    | Content.EmailCapturePopupDocument
    | Content.EmailCapturePopupStagingDocument;
  barIsActivated: boolean;
  popupIsActivated: boolean;
}
export default function MailCaptureBar({
  mailCaptureData,
  barIsActivated,
  popupIsActivated,
}: Props) {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [mailSubmitted, setMailSubmitted] = useState(false);
  const handleOpen = () => {
    setIsOpen(true);
  };
  useEffect(() => {
    const initModalDisplay = () => {
      const referralModalStorage = Boolean(getFromStorage(MAIL_CAPTURE_MODAL));
      const hasAlreadyOpened = referralModalStorage ? false : true;
      if (hasAlreadyOpened) {
        setIsOpen(hasAlreadyOpened);
      }
    };
    const initBarDisplay = () => {
      const mailCaptureBarStorage = Boolean(
        getFromStorage(MAIL_CAPTURE_SUBMITTED),
      );
      const canShowBar = mailCaptureBarStorage ? false : true;
      setMailSubmitted(!canShowBar);
    };
    void initBarDisplay();
    setTimeout(() => {
      void initModalDisplay();
    }, MODAL_OPENING_DELAY);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleMailSubmitted = () => {
    setMailSubmitted(true);
  };

  return !mailSubmitted ? (
    <>
      {barIsActivated && popupIsActivated && (
        <FixedBar
          text={mailCaptureData?.data.fixedBarText}
          button={{
            label: mailCaptureData?.data.barButtonLabel?.toString() ?? "",
            click: () => handleOpen(),
          }}
          position={EFixedBarPosition.TOP}
          className={style.bar}
          actionClassName={style.action}
          wrapClassName={style.wrap}
        />
      )}
      {popupIsActivated && (
        <EmailCaptureModal
          modalContent={mailCaptureData}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          mailSubmitted={handleMailSubmitted}
        />
      )}
    </>
  ) : null;
}
